import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import auth from "../../../../providers/Auth.Provider";
import NewQuestion from "./Question/NewQuestion";
import QuestionList from "./Question/QuestionList";
import AssessmentOptionList from "./Option/ListOption";
import { useQuery, useMutation, useLazyQuery } from "@apollo/react-hooks";
import { GET_QUESTIONS_CATEGORY, GET_QUESTIONS, NEW_QUESTION, UPDATE_QUESTION, NEW_OPTION, UPDATE_OPTION, UPDATE_SCORE, UPDATE_PROPS } from "../../../../queries/assessment.query";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";
import UpdateQuestionForm from "./Question/UpdateQuestion";
import NewAssessmentOptionForm from "./Option/NewOption";
import UpdateAssessmentOptionForm from "./Option/UpdateOption";
import ScoreGuide from "./Question/Score.jsx";
import AdditionalInformation from "./Question/Additional.jsx";
import SelectItem from "react-dropdown-select";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

const AssessmentQuestionOption = ({ match }) => {
    // local state
    const [question, setQuestion] = useState(null);
    const [option, setOption] = useState(null);
    const [newQuestion, setNewQuestion] = useState(false);
    const [newOption, setNewOption] = useState(false);
    const [updateQuestion, setUpdateQuestion] = useState(false);
    const [updateOption, setUpdateOption] = useState(false);
    const [assessment, setAssessment] = useState(null);
    const [optList, setOptList] = useState([]);

    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();

    // type and categories queries
    const { loading, data, error } = useQuery(GET_QUESTIONS_CATEGORY, {
        variables: { site: site && site.id }
    });

    // question query
    const [FetchQuestions, { loading: qLoading, data: qData, error: qError }] = useLazyQuery(GET_QUESTIONS);

    /**
     * New Question
     */
    const [SendAssessment, { loading: nqLoading }] = useMutation(NEW_QUESTION, {
        update(caches, { data: { NewAssessmentQuestion } }) {
            const { GetAssessmentQuestions } = caches.readQuery({
                query: GET_QUESTIONS,
                variables: {
                    assessment: assessment.id
                }
            });
            GetAssessmentQuestions.docs.unshift(NewAssessmentQuestion.doc);
            caches.writeQuery({
                data: { GetAssessmentQuestions },
                query: GET_QUESTIONS,
                variables: {
                    assessment: assessment.id
                }
            });
        },
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.NewAssessmentQuestion) {
                toast.success(d.NewAssessmentQuestion.message);
            }
        }
    });

    /**
     * New Option
     */
    const [NewOptionFunc, { loading: noLoading }] = useMutation(NEW_OPTION, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d) {
                const { message, doc } = d.NewAssessmentOption;
                const _list = Array.from(optList);
                _list.unshift(doc);
                setOptList(_list);
                toast.success(message);
            }
        }
    });
    // Update Question
    const [updateQuestionFunc, { loading: uqLoading, error: uqError }] = useMutation(UPDATE_QUESTION, {
        onCompleted: data => {
            if (data.UpdateAssessmentQuestion) {
                const { message } = data.UpdateAssessmentQuestion;
                toast.success(message);
                setQuestion(null);
                setUpdateOption(false);
            }
        }
    });
    // UPDATE_SCORE
    const [UpdateScoreFunc, { loading: sLoading, error: sError, data: sData }] = useMutation(UPDATE_SCORE);

    // UPDATE_PROPS
    const [UpdateMoreFunc, { loading: _Loading, error: _Error, data: _Data }] = useMutation(UPDATE_PROPS);

    // UPDATE OPTION
    const [updateOptionFunc, { loading: uoLoading, error: uoError }] = useMutation(UPDATE_OPTION);

    const title = "Assessment Question and Option";

    return (
        <>
            <Helmet>
                {title} | {appName}
            </Helmet>

            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>Select Assessment Type</header>
                            <LoadingSpinner loading={loading} bar={true} />
                        </div>
                        <div className="card-body">
                            <SelectItem
                                className="input-height"
                                options={data && data.GetAssessments.docs}
                                valueField="id"
                                labelField="name"
                                onChange={([item]) => {
                                    setAssessment(item);
                                    if (item) {
                                        FetchQuestions({
                                            variables: {
                                                assessment: item.id
                                            }
                                        });
                                    }
                                }}
                                searchable={true}
                                color="#0066f5"
                                searchBy="name"
                                clearable={true}
                                separator={true}
                            />
                        </div>
                    </div>
                </div>
                {!question && assessment && !newQuestion && !updateQuestion && (
                    <div className="col-md-12 col-sm-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Question</header>
                                <div className="tools">
                                    <button
                                        onClick={() => {
                                            setNewQuestion(true);
                                            // scroll to the top
                                            document.body.scrollTop = 0;
                                            document.documentElement.scrollTop = 0;
                                        }}
                                        className="mdl-button mdl-js-button mdl-js-ripple-effect margin-right-10 btn-circle btn-success"
                                    >
                                        <i className="material-icons">add_circle_outline</i> New Question
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20">
                                <div className="mb-5">
                                    <LoadingSpinner loading={loading || qLoading} />
                                    <AlertMessage message={(error && error.message) || (qError && qError.message)} failed={true} />
                                </div>
                                <QuestionList
                                    items={qData && qData.GetAssessmentQuestions.docs}
                                    onSelect={item => {
                                        setQuestion(item);
                                        setOptList(item.options);
                                        document.body.scrollTop = 0;
                                        document.documentElement.scrollTop = 0;
                                    }}
                                    onEdit={item => {
                                        setQuestion(item);
                                        setUpdateQuestion(true);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!question && assessment && !updateQuestion && (
                    <div className="col-12">
                        {newQuestion && (
                            <div className="card fade-in">
                                <div className="card-head">
                                    <header>New Question</header>
                                </div>
                                <div className="card-body">
                                    {nqLoading && <LoadingSpinner loading={nqLoading} />}
                                    <NewQuestion
                                        categories={data && data.GetAssessmentCategories.docs}
                                        onCancel={() => setNewQuestion(false)}
                                        onSubmit={async newQuestion => {
                                            await SendAssessment({
                                                variables: {
                                                    assessment: assessment.id,
                                                    model: newQuestion
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {updateQuestion && question && (
                    <div className="card fade-in m-b-20">
                        <div className="card-head">
                            <header>Update Question</header>
                        </div>
                        <div className="card-body">
                            {uqLoading && <LoadingSpinner loading={uqLoading} />}
                            <AlertMessage message={uqError && uqError.message} failed={true} />

                            <UpdateQuestionForm
                                onCancel={() => setUpdateQuestion(false)}
                                onSubmit={async updatedName => {
                                    await updateQuestionFunc({
                                        variables: {
                                            id: question.id,
                                            name: updatedName
                                        }
                                    });
                                    setUpdateQuestion(false);
                                }}
                                currentName={question.name}
                            />
                        </div>
                    </div>
                )}

                {question && (
                    <div className="col-md-6 col-sm-12 fade-in">
                        {updateOption && (
                            <div className="card fade-in m-b-20">
                                <div className="card-head">
                                    <header>Update Option</header>
                                </div>
                                <div className="card-body">
                                    {uoLoading && <LoadingSpinner loading={uoLoading} />}
                                    <AlertMessage message={uoError && uoError.message} failed={true} />

                                    <UpdateAssessmentOptionForm
                                        onCancel={() => setUpdateOption(false)}
                                        onSubmit={async ({ name, value }) => {
                                            await updateOptionFunc({
                                                variables: {
                                                    id: option.id,
                                                    name,
                                                    value
                                                }
                                            });
                                            setUpdateOption(false);
                                        }}
                                        value={option.value}
                                        name={option.name}
                                    />
                                </div>
                            </div>
                        )}
                        {newOption && (
                            <div className="card fade-in">
                                <div className="card-head">
                                    <header>New Option</header>
                                </div>
                                <div className="card-body m-b-20">
                                    {noLoading && <LoadingSpinner loading={noLoading} />}
                                    <NewAssessmentOptionForm
                                        onCancel={() => setNewOption(false)}
                                        onSubmit={async ({ name, value }) => {
                                            await NewOptionFunc({
                                                variables: {
                                                    question: question.id,
                                                    model: { value, name }
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button onClick={() => setQuestion(null)} title="Back" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Options
                                </header>
                                <div className="tools">
                                    <button
                                        onClick={() => {
                                            setNewOption(true);
                                        }}
                                        className="mdl-button mdl-js-button mdl-js-ripple-effect margin-right-10 btn-circle btn-success"
                                    >
                                        <i className="material-icons">add_circle_outline</i> New Option
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20">
                                <h5>{question.name}</h5>
                                <p>
                                    Category: <strong>{question.category.name}</strong>
                                </p>
                                <hr />
                                <h4>Options</h4>
                                <AssessmentOptionList
                                    items={optList}
                                    onEdit={item => {
                                        setOption(item);
                                        setUpdateOption(true);
                                        document.body.scrollTop = 0;
                                        document.documentElement.scrollTop = 0;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {assessment && !question && !newQuestion && !updateQuestion && (
                    <div className="col-md-12">
                        <div className="row">
                            <div className="fade-in col-md-8 col-sm-12">
                                <div className="card">
                                    <div className="card-head">
                                        <header>Score Guide</header>
                                    </div>
                                    <div className="card-body min-card">
                                        <LoadingSpinner loading={sLoading} />
                                        <AlertMessage message={sError && sError.message} failed={true} />
                                        <AlertMessage message={sData && sData.AddScoreGuide.message} />
                                        <ScoreGuide
                                            items={assessment.scoreGuide}
                                            onSubmit={async item => {
                                                await UpdateScoreFunc({
                                                    variables: {
                                                        id: assessment.id,
                                                        model: item
                                                    }
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fade-in col-md-4 col-sm-12">
                                <div className="card">
                                    <div className="card-head">
                                        <header>Additional Props</header>
                                    </div>
                                    <div className="card-body min-card">
                                        <LoadingSpinner loading={_Loading} />
                                        <AlertMessage message={_Error && _Error.message} failed={true} />
                                        <AlertMessage message={_Data && _Data.AddAddtionalProp.message} />
                                        <AdditionalInformation
                                            onSubmit={async ({ name }) => {
                                                await UpdateMoreFunc({
                                                    variables: {
                                                        name,
                                                        id: assessment.id
                                                    }
                                                });
                                            }}
                                            items={assessment.additional}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AssessmentQuestionOption;
